import * as React from 'react'
import { IMobilityOptionCategoryObject } from '../../types/index'
import Modal from '../ui/Modal'
import MobilityOptionsCategoryListItem from './MobilityOptionsEditCategoryModalListItem'

export interface IMobilityOptionsEditCategoryModalProps {
  onClose: () => void
  onRemove: (category: IMobilityOptionCategoryObject) => void
  onCreate: (name: string) => void
  categories: IMobilityOptionCategoryObject[]
}

interface IMobilityOptionsEditCategoryModalState {
  isPending: boolean
  newCategory: string
}

class MobilityOptionsEditCategoryModal extends React.Component<
  IMobilityOptionsEditCategoryModalProps,
  IMobilityOptionsEditCategoryModalState
> {
  constructor(props: IMobilityOptionsEditCategoryModalProps) {
    super(props)
    this.state = {
      isPending: false,
      newCategory: ''
    }
  }

  public render() {
    const { categories } = this.props
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='MobilityOptionsModalTitle font-small weight-400 font-grey2'>CATEGORY</span>
            {/* Category list */}
            <div className='MobilityOptionsCategoryList pt2'>
              {categories &&
                Object.keys(categories).map((item, i) => (
                  <MobilityOptionsCategoryListItem
                    onRemove={this.onRemoveCategory}
                    key={`tmli-${i}`}
                    category={categories[item]}
                  />
                ))}
            </div>
            {/* New Category  */}
            <div className='mt2 ml2 mr2'>
              <label className='font-small weight-300 font-grey3'>New Category</label>
              <div className='flex'>
                <input
                  type='text'
                  name='category'
                  value={this.state.newCategory}
                  onChange={this.handleCategoryChanged}
                />
                <button
                  type='button'
                  disabled={this.state.newCategory.length === 0}
                  onClick={this.handleAddCategoryClick}
                  className='btn bg-green ml1 rounded font-white weight-300'
                >
                  +
                </button>
              </div>
            </div>
            {/* Buttons */}
            <div className='flex items-center justify-end mt3'>
              <button type='button' onClick={this.props.onClose} className='btn bg-white rounded font-light-grey mr2'>
                Cancel
              </button>

              <button
                type='button'
                disabled={this.state.isPending}
                onClick={this.handleSaveClick}
                className='btn bg-green rounded font-white weight-300'
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private onRemoveCategory = (category: IMobilityOptionCategoryObject) => {
    this.props.onRemove(category)
  }

  private handleCategoryChanged = (e: any) => {
    this.setState({ ...this.state, newCategory: e.target.value })
  }

  private handleSaveClick = () => {
    this.setState({ ...this.state, isPending: true })
    this.props.onClose()
  }

  private handleAddCategoryClick = () => {
    this.props.onCreate(this.state.newCategory)
  }
}

export default MobilityOptionsEditCategoryModal



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsEditCategoryModal.tsx